import { getSrcs, imageUrl } from '@helpers/image';
import { Device, from } from '@helpers/media';
import { videoUrl } from '@helpers/video';
import { ReviewScoreHomepage } from '@stories/Components/Misc/ReviewScore/ReviewScore';
import * as React from 'react';
import { useMount } from 'react-use';
import S from './HomepageHeroBanner.styles';
const HomepageHeroBanner = (props) => {
    const [animate, setAnimate] = React.useState(false);
    const [video, setVideo] = React.useState();
    const hasVideo = props.videoLandscape && props.videoPortrait;
    useMount(() => {
        setAnimate(true);
        if (hasVideo) {
            const isLandscape = window.matchMedia('(orientation: landscape)');
            isLandscape.addEventListener('change', (isLandscape) => {
                if (isLandscape.matches) {
                    setVideo(props.videoLandscape);
                }
                else {
                    setVideo(props.videoPortrait);
                }
            });
            if (isLandscape.matches) {
                setVideo(props.videoLandscape);
            }
            else {
                setVideo(props.videoPortrait);
            }
        }
    });
    return (React.createElement(S.Container, { id: props.id, layout: "fullWidth", "data-animate": animate, "data-theme": props.theme },
        React.createElement(S.ContentWrapper, null,
            props.reviewScore && (React.createElement(S.ReviewScoreWrapper, null,
                React.createElement(ReviewScoreHomepage, { rating: props.reviewScore?.rating, reviews: props.reviewScore?.reviews, link: props.reviewScore?.link }))),
            React.createElement(S.Title, { "data-animate": "true", style: { '--length': props.title.length }, dangerouslySetInnerHTML: { __html: processTitle(props.title) } }),
            React.createElement(S.Content, { dangerouslySetInnerHTML: { __html: props.content } }),
            React.createElement(S.Actions, null,
                React.createElement(S.SearchCTA, { href: props.cta?.url, target: props.cta?.target, fillDirection: "right", noIcon: true, buttonType: "plain" }, props.cta?.text),
                props.discoverCta && (React.createElement(S.DiscoverCTA, { href: props.discoverCta.url, target: props.discoverCta.target, fillDirection: "right", noIcon: true, buttonType: "outline-white" }, props.discoverCta?.text)))),
        React.createElement(S.MediaWrapper, null, renderMedia())));
    function processTitle(value) {
        const regex = /\*(.+)\*/;
        return value.replace(regex, '<u>$1</u>');
    }
    function renderMedia() {
        if (video) {
            return (React.createElement(S.Video, { key: video, autoPlay: true, loop: true, muted: true, playsInline: true },
                React.createElement("source", { src: videoUrl(video, { audio: 'none', format: 'webm' }), type: "video/webm" }),
                React.createElement("source", { src: videoUrl(video, { audio: 'none', format: 'mp4' }), type: "video/mp4" })));
        }
        if (!hasVideo && props.image) {
            return (React.createElement("picture", null,
                React.createElement("source", { media: from(Device.Tablet), sizes: "100vw", src: imageUrl(props.image, { width: 1920, heightratio: 1870 / 1025 }), srcSet: getSrcs(props.image, 1920, 768, 5, 1870 / 1025).join(',') }),
                React.createElement(S.Image, { alt: props.image.altText ?? '', loading: "eager", role: !props.image.altText ? 'presentation' : undefined, sizes: "100vw", src: imageUrl(props.image, { width: 768, heightratio: 1 }), srcSet: getSrcs(props.image, 768, 400, 5, 1).join(',') })));
        }
        return null;
    }
};
export default HomepageHeroBanner;
